import React, { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import ConsumerListingComponent from "./consumerListing.page"
import {AccessRights} from "lib/constants/accessRights"
import LoadingComponent from "components/loading"
import {canAccess} from "../../../profile/redux/selector/profile.selector";

export default function ConsumerListingContainer() {
  const token = useSelector(state => state.session.accessToken)
  const history = useHistory()
  const hasConsumerViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Consumer.LIST_READ));
  const lang = useSelector(state => state.constant.languages)
  useEffect(() => {
    if(!hasConsumerViewAccessRight){
      history.push('/admin/dashboard')
    }
  }, [history, hasConsumerViewAccessRight])

  if (!hasConsumerViewAccessRight) return <LoadingComponent />

  return (
    <ConsumerListingComponent
      token={token} 
      lang={lang}/>
  )
}
